import { render, staticRenderFns } from "./PaymentMethodDialogAdd.vue?vue&type=template&id=5239ec87&scoped=true&"
import script from "./PaymentMethodDialogAdd.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodDialogAdd.vue?vue&type=script&lang=js&"
import style0 from "./PaymentMethodDialogAdd.vue?vue&type=style&index=0&id=5239ec87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5239ec87",
  null
  
)

/* custom blocks */
import block0 from "./PaymentMethodDialogAdd.vue?vue&type=custom&index=0&blockType=i18n&lang=yml&locale=ru"
if (typeof block0 === 'function') block0(component)
import block1 from "./PaymentMethodDialogAdd.vue?vue&type=custom&index=1&blockType=i18n&lang=yml&locale=en"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCard,VCardText,VCardTitle,VCheckbox})
